import { render, staticRenderFns } from "./addStaffOfficial.vue?vue&type=template&id=220d9658&"
import script from "./addStaffOfficial.vue?vue&type=script&lang=js&"
export * from "./addStaffOfficial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports